export const REFERENCE_VISIT_STATUS = Object.freeze({
  DONE: 'DONE',
  CANCELED: 'CANCELED',
  SCHEDULED: 'SCHEDULED',
  WAITING_CONFIRMATION: 'WAITING_CONFIRMATION',
  REQUEST_CANCELED: 'REQUEST_CANCELED',
  UNSUCCESSFUL: 'UNSUCCESSFUL',
  STALLED: 'STALLED',
});

export const REFERENCE_VISIT_STATUS_V3 = Object.freeze({
  DONE: 'DONE',
  CANCELED: 'CANCELED',
  CONFIRMED: 'CONFIRMED',
  REQUESTED: 'REQUESTED',
  REQUEST_CANCELED: 'REQUEST_CANCELED',
  UNSUCCESSFUL: 'UNSUCCESSFUL',
  STALLED: 'STALLED',
});

export const REFERENCE_VISIT_REQUESTED_FIELDS = Object.freeze({
  ACTOR_DETAILS: 'ACTOR_DETAILS',
  HOUSE_DETAILS: 'HOUSE_DETAILS',
  STRUCTURED_STATUS: 'STRUCTURED_STATUS',
  FOLLOW_UP: 'FOLLOW_UP',
  TEMP_MIGRATION_SUPPORT: 'TEMP_MIGRATION_SUPPORT',
});

export const REFERENCE_DAYS_TO_DISPLAY = Object.freeze({
  SALE: 8,
  RENT: 8,
});

export const REFERENCE_DEFAULT_PAGE_SIZE = 100;

export const REFERENCE_DEFAULT_CURRENT_PAGE = 1;

export const REFERENCE_DEFAULT_REQUESTED_FIELDS = Object.freeze([
  REFERENCE_VISIT_REQUESTED_FIELDS.ACTOR_DETAILS,
  REFERENCE_VISIT_REQUESTED_FIELDS.HOUSE_DETAILS,
  REFERENCE_VISIT_REQUESTED_FIELDS.STRUCTURED_STATUS,
  REFERENCE_VISIT_REQUESTED_FIELDS.FOLLOW_UP,
  REFERENCE_VISIT_REQUESTED_FIELDS.TEMP_MIGRATION_SUPPORT,
]);

export const REFERENCE_DEFAULT_VISIT_STATUS = Object.freeze([
  REFERENCE_VISIT_STATUS_V3.DONE,
  REFERENCE_VISIT_STATUS_V3.CANCELED,
  REFERENCE_VISIT_STATUS_V3.CONFIRMED,
  REFERENCE_VISIT_STATUS_V3.REQUESTED,
  REFERENCE_VISIT_STATUS_V3.REQUEST_CANCELED,
  REFERENCE_VISIT_STATUS_V3.UNSUCCESSFUL,
  REFERENCE_VISIT_STATUS_V3.STALLED,
]);

export const REFERENCE_VISIT_CARD_STATUS = Object.freeze({
  DONE: 'DONE',
  NOT_HAPPENED: 'NOT_HAPPENED',
  PENDING: 'PENDING',
  REQUESTED: 'REQUESTED',
  CONFIRMED: 'CONFIRMED',
  SCHEDULE_SCHEDULED: 'SCHEDULE_SCHEDULED',
  CANCELED: 'CANCELED',
  UNAVAILABLE_HOURS: 'UNAVAILABLE_HOURS',
  UNSUCCESSFUL: 'UNSUCCESSFUL',
});

export const REFERENCE_ACTOR_ROLE = Object.freeze({
  SUPPLY: 'SUPPLY',
});

export const REFERENCE_CANCELLATION_REASON = Object.freeze({
  PERSON_CAN_NOT_ATTEND: 'PERSON_CAN_NOT_ATTEND',
  OWNER_CANNOT_THIS_TIME: 'owner_cannot_this_time',
  PERSON_CANNOT_ATTEND: 'person_cannot_attend',
});

export const REFERENCE_ACCESS_AUTHORIZATION = Object.freeze({
  NONE: 'NONE',
  OWNER_PRESENT: 'OWNER_PRESENT',
});

export const REFERENCE_VISIT_TYPES = Object.freeze({
  PRESENTIAL: 'PRESENTIAL',
});

export const REFERENCE_PRESENCE_ANSWER = Object.freeze({
  YES: 'yes',
  NO: 'no',
  DONT_KNOW: 'dont_know',
});

export const REFERENCE_ENTRANCE_BLOCKER_OPTIONS = Object.freeze({
  WRONG_ENTRANCE_INFO: 'wrong_info',
});

export const REFERENCE_CORRECT_ENTRY_INFO_OPTIONS = Object.freeze({
  DONT_KNOW: 'dont_know',
  OWNER_PRESENT: 'OWNER_PRESENT',
});

export const REFERENCE_ENTRANCE_PROBLEM_REASON = Object.freeze({
  LANDLORD_NO_SHOW: 'LANDLORD_NO_SHOW',
  MISSPLACED_KEYS: 'MISSPLACED_KEYS',
});

export const REFERENCE_HOUSE_PRINCIPAL_INFOS = Object.freeze({
  BALCONY: 'BALCONY',
  GYM: 'GYM',
  POOL: 'POOL',
});

export const LOCAL_VISITA_STATUS_BY_REFERENCE = Object.freeze({
  [REFERENCE_VISIT_STATUS.DONE]: 'realizada',
  [REFERENCE_VISIT_STATUS.CANCELED]: 'cancelada',
  [REFERENCE_VISIT_STATUS.SCHEDULED]: 'confirmada',
  [REFERENCE_VISIT_STATUS.WAITING_CONFIRMATION]: 'solicitada',
  [REFERENCE_VISIT_STATUS.REQUEST_CANCELED]: 'cancelada',
  [REFERENCE_VISIT_STATUS.UNSUCCESSFUL]: 'nao_sucedida',
  [REFERENCE_VISIT_STATUS.STALLED]: 'paralisada',
});

export const LOCAL_CARD_STATUS_BY_REFERENCE = Object.freeze({
  [REFERENCE_VISIT_CARD_STATUS.DONE]: 'realizada',
  [REFERENCE_VISIT_CARD_STATUS.NOT_HAPPENED]: 'nao_compareceu',
  [REFERENCE_VISIT_CARD_STATUS.PENDING]: 'pendente',
  [REFERENCE_VISIT_CARD_STATUS.REQUESTED]: 'aguardando_confirmacao',
  [REFERENCE_VISIT_CARD_STATUS.CONFIRMED]: 'confirmada',
  [REFERENCE_VISIT_CARD_STATUS.SCHEDULE_SCHEDULED]: 'agendada',
  [REFERENCE_VISIT_CARD_STATUS.CANCELED]: 'cancelada',
  [REFERENCE_VISIT_CARD_STATUS.UNAVAILABLE_HOURS]: 'horario_indisponivel',
  [REFERENCE_VISIT_CARD_STATUS.UNSUCCESSFUL]: 'nao_sucedida',
});

export const REFERENCE_SCHEDULE_TYPE = Object.freeze({
  VISIT: 'VISIT',
  FIXED_BLOCK: 'FIXED_BLOCK',
  TEMPORARY_BLOCK: 'TEMPORARY_BLOCK',
});

export const REFERENCE_FULLDAY_SCHEDULE = Object.freeze({
  startTime: '08:00',
  endTime: '20:00',
  isEntireDay: true,
});

export const REFERENCE_SCHEDULE_BLOCK_TYPES = Object.freeze([
  REFERENCE_SCHEDULE_TYPE.FIXED_BLOCK,
  REFERENCE_SCHEDULE_TYPE.TEMPORARY_BLOCK,
]);

const compactObject = object =>
  Object.entries(object).reduce((acc, [key, value]) => {
    if (Array.isArray(value)) {
      const compacted = value.filter(item => item !== null && item !== '');
      if (compacted.length) acc[key] = compacted;
      return acc;
    }
    if (value !== '' && value !== null && value !== undefined) {
      acc[key] = value;
    }
    return acc;
  }, {});

const toDate = value => {
  if (!value) return null;
  if (value instanceof Date) return value;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const timeStringToDate = (time, now = new Date()) => {
  if (!time) return null;
  const [hours, minutes = '0'] = String(time).split(':');
  const date = new Date(now);
  date.setHours(Number(hours), Number(minutes), 0, 0);
  return Number.isNaN(date.getTime()) ? null : date;
};

const structuredStatusValue = (structuredStatus, key) => {
  const source = structuredStatus || {};
  return (
    source[key] ||
    source[key.replace(/[A-Z]/g, char => `_${char.toLowerCase()}`)]
  );
};

export const mapReferenceStatusFromV3 = status => {
  switch (String(status || '').toUpperCase()) {
    case REFERENCE_VISIT_STATUS_V3.DONE:
      return REFERENCE_VISIT_STATUS.DONE;
    case REFERENCE_VISIT_STATUS_V3.CANCELED:
      return REFERENCE_VISIT_STATUS.CANCELED;
    case REFERENCE_VISIT_STATUS_V3.CONFIRMED:
      return REFERENCE_VISIT_STATUS.SCHEDULED;
    case REFERENCE_VISIT_STATUS_V3.REQUEST_CANCELED:
      return REFERENCE_VISIT_STATUS.REQUEST_CANCELED;
    case REFERENCE_VISIT_STATUS_V3.UNSUCCESSFUL:
      return REFERENCE_VISIT_STATUS.UNSUCCESSFUL;
    case REFERENCE_VISIT_STATUS_V3.STALLED:
      return REFERENCE_VISIT_STATUS.STALLED;
    case REFERENCE_VISIT_STATUS_V3.REQUESTED:
    default:
      return REFERENCE_VISIT_STATUS.WAITING_CONFIRMATION;
  }
};

export const mapReferenceStatusToVisitaStatus = status =>
  LOCAL_VISITA_STATUS_BY_REFERENCE[status] || 'solicitada';

export const mapV3StatusToVisitaStatus = status => {
  if (String(status || '').toUpperCase() === 'SCHEDULED') return 'agendada';
  return mapReferenceStatusToVisitaStatus(mapReferenceStatusFromV3(status));
};

export const hasReferenceVisitStarted = (startTime, now = new Date()) => {
  const start =
    startTime instanceof Date || String(startTime || '').includes('T')
      ? toDate(startTime)
      : timeStringToDate(startTime, now);
  const current = toDate(now) || new Date();
  if (!start) return false;
  return start.getTime() <= current.getTime();
};

export const referenceVisitNotHappened = ({ visitNotHappen } = {}) =>
  visitNotHappen
    ? REFERENCE_VISIT_CARD_STATUS.NOT_HAPPENED
    : REFERENCE_VISIT_CARD_STATUS.DONE;

export const isReferenceVisitConfirmed = status =>
  status === REFERENCE_VISIT_STATUS.SCHEDULED;

export const getReferenceScheduledCardStatus = ({
  status,
  startTime,
  isCurrentDate,
  now = new Date(),
  isThirdParty = false,
  isVisitConfirmationByAgentEnabled = false,
} = {}) => {
  if (isCurrentDate && hasReferenceVisitStarted(startTime, now)) {
    return REFERENCE_VISIT_CARD_STATUS.PENDING;
  }

  const isConfirmed = isReferenceVisitConfirmed(status);
  if (isVisitConfirmationByAgentEnabled && !isConfirmed) {
    return REFERENCE_VISIT_CARD_STATUS.REQUESTED;
  }

  if (isConfirmed && (isThirdParty || isVisitConfirmationByAgentEnabled)) {
    return REFERENCE_VISIT_CARD_STATUS.CONFIRMED;
  }

  return REFERENCE_VISIT_CARD_STATUS.SCHEDULE_SCHEDULED;
};

export const getReferenceUnavailableHoursCardStatus = (
  structuredStatus,
  isVisitConfirmationByAgentEnabled,
  isVisitStatusUnavailableHoursEnabled
) => {
  const reason = String(
    structuredStatusValue(structuredStatus, 'reason') || ''
  ).toUpperCase();
  const onBehalfOfRole = String(
    structuredStatusValue(structuredStatus, 'onBehalfOfRole') || ''
  ).toUpperCase();
  const isOwnerUnavailable = [
    REFERENCE_CANCELLATION_REASON.PERSON_CAN_NOT_ATTEND,
    REFERENCE_CANCELLATION_REASON.OWNER_CANNOT_THIS_TIME.toUpperCase(),
    REFERENCE_CANCELLATION_REASON.PERSON_CANNOT_ATTEND.toUpperCase(),
  ].includes(reason);

  if (
    isVisitConfirmationByAgentEnabled &&
    isVisitStatusUnavailableHoursEnabled &&
    isOwnerUnavailable &&
    onBehalfOfRole === REFERENCE_ACTOR_ROLE.SUPPLY
  ) {
    return REFERENCE_VISIT_CARD_STATUS.UNAVAILABLE_HOURS;
  }

  return REFERENCE_VISIT_CARD_STATUS.CANCELED;
};

export const getReferenceVisitCardStatus = ({
  status,
  startTime,
  isCurrentDate,
  visitNotHappen,
  isThirdParty = false,
  structuredStatus,
  isVisitConfirmationByAgentEnabled = false,
  isVisitStatusUnavailableHoursEnabled = false,
  now = new Date(),
} = {}) => {
  switch (status) {
    case REFERENCE_VISIT_STATUS.DONE:
      return referenceVisitNotHappened({ visitNotHappen });
    case REFERENCE_VISIT_STATUS.REQUEST_CANCELED:
      return getReferenceUnavailableHoursCardStatus(
        structuredStatus,
        isVisitConfirmationByAgentEnabled,
        isVisitStatusUnavailableHoursEnabled
      );
    case REFERENCE_VISIT_STATUS.CANCELED:
      return REFERENCE_VISIT_CARD_STATUS.CANCELED;
    case REFERENCE_VISIT_STATUS.UNSUCCESSFUL:
      return REFERENCE_VISIT_CARD_STATUS.UNSUCCESSFUL;
    case REFERENCE_VISIT_STATUS.WAITING_CONFIRMATION:
    case REFERENCE_VISIT_STATUS.SCHEDULED:
      return getReferenceScheduledCardStatus({
        status,
        startTime,
        isCurrentDate,
        now,
        isThirdParty,
        isVisitConfirmationByAgentEnabled,
      });
    default:
      return null;
  }
};

export const getLocalCardStatusFromReference = referenceCardStatus =>
  LOCAL_CARD_STATUS_BY_REFERENCE[referenceCardStatus] || null;

export const sortByReferenceHourString = (previous, next) => {
  const previousTime = previous.startTime || previous.time || '';
  const nextTime = next.startTime || next.time || '';
  if (previousTime < nextTime) return -1;
  if (previousTime > nextTime) return 1;
  return 0;
};

const addReferenceScheduleType = type => schedule => ({
  ...schedule,
  type,
});

export const buildReferenceVisitList = (visits = {}) => {
  const groupedVisits = visits
    ? Object.values(visits)
        .sort(sortByReferenceHourString)
        .reduce((acc, visit) => {
          const startTime = visit.startTime || visit.time;
          acc[startTime] = [...(acc[startTime] || []), visit];
          return acc;
        }, {})
    : {};

  return Object.entries(groupedVisits).map(([startTime, visitList]) => ({
    startTime,
    type: REFERENCE_SCHEDULE_TYPE.VISIT,
    visits: visitList,
  }));
};

export const mergeReferenceTemporaryAndFixedBlocks = (
  temporaryIntervals = [],
  fixedIntervals = []
) => {
  const blocks = [];
  const sortedBlocks = [
    ...fixedIntervals.map(
      addReferenceScheduleType(REFERENCE_SCHEDULE_TYPE.FIXED_BLOCK)
    ),
    ...temporaryIntervals.map(
      addReferenceScheduleType(REFERENCE_SCHEDULE_TYPE.TEMPORARY_BLOCK)
    ),
  ].sort(sortByReferenceHourString);

  if (sortedBlocks.length === 0) return blocks;
  blocks.push(sortedBlocks[0]);

  for (let index = 0; index < sortedBlocks.length; index += 1) {
    const lastBlock = blocks[blocks.length - 1];
    const currentBlock = sortedBlocks[index];

    if (lastBlock.endTime <= currentBlock.startTime) {
      blocks.push(currentBlock);
    } else if (lastBlock.endTime <= currentBlock.endTime) {
      if (
        lastBlock.type === REFERENCE_SCHEDULE_TYPE.TEMPORARY_BLOCK &&
        currentBlock.type === REFERENCE_SCHEDULE_TYPE.FIXED_BLOCK
      ) {
        lastBlock.endTime = currentBlock.startTime;
        blocks.push(currentBlock);
      } else if (
        lastBlock.type === REFERENCE_SCHEDULE_TYPE.FIXED_BLOCK &&
        currentBlock.type === REFERENCE_SCHEDULE_TYPE.TEMPORARY_BLOCK
      ) {
        blocks.push({ ...currentBlock, startTime: lastBlock.endTime });
      } else {
        lastBlock.endTime = currentBlock.endTime;
      }
    } else if (
      lastBlock.endTime > currentBlock.endTime &&
      lastBlock.type === REFERENCE_SCHEDULE_TYPE.TEMPORARY_BLOCK &&
      currentBlock.type === REFERENCE_SCHEDULE_TYPE.FIXED_BLOCK
    ) {
      blocks.push(currentBlock);
      blocks.push({
        type: REFERENCE_SCHEDULE_TYPE.TEMPORARY_BLOCK,
        startTime: currentBlock.endTime,
        endTime: lastBlock.endTime,
      });
      lastBlock.endTime = currentBlock.startTime;
    }
  }

  return blocks;
};

export const buildReferenceBlockList = (
  temporaryBlocks = {},
  fixedBlocks = {}
) => {
  if (fixedBlocks?.isEntireDay) {
    return [
      {
        ...REFERENCE_FULLDAY_SCHEDULE,
        type: REFERENCE_SCHEDULE_TYPE.FIXED_BLOCK,
      },
    ];
  }

  if (temporaryBlocks?.isEntireDay) {
    return [
      {
        ...REFERENCE_FULLDAY_SCHEDULE,
        type: REFERENCE_SCHEDULE_TYPE.TEMPORARY_BLOCK,
      },
    ];
  }

  return mergeReferenceTemporaryAndFixedBlocks(
    temporaryBlocks?.intervals,
    fixedBlocks?.intervals
  );
};

export const buildReferenceScheduleGroups = (
  visits = {},
  temporaryBlocks = {},
  fixedBlocks = {}
) => {
  const visitList = buildReferenceVisitList(visits);
  const blockList = buildReferenceBlockList(temporaryBlocks, fixedBlocks);
  let block = {};

  return [...blockList, ...visitList]
    .sort(sortByReferenceHourString)
    .map(schedule => {
      const newSchedule = { ...schedule };
      if (REFERENCE_SCHEDULE_BLOCK_TYPES.includes(schedule.type)) {
        block = schedule;
      } else if (
        schedule.startTime >= block.startTime &&
        schedule.startTime < block.endTime
      ) {
        newSchedule.isWithinBlockedSchedule = true;
      }
      return newSchedule;
    });
};

export const formatReferenceHouseDetails = houseDetails => {
  const { houseId: id, shortId, type, address, image } = houseDetails || {};
  return {
    id,
    shortId,
    type,
    address: {
      street: address?.street,
      complement: address?.complement,
      number: address?.number,
      region: address?.neighborhood,
      city: address?.city,
      zipCode: address?.zipCode,
    },
    mainImageUrl: image,
  };
};

export const formatReferenceVisitors = visit => {
  const { code: visitCode, singleHouseVisitDetails } = visit || {};
  const { actorDetails, structuredStatus, followUp, tempMigrationSupport } =
    singleHouseVisitDetails || {};
  const { visitDemand } = actorDetails || {};

  return [
    {
      id: visitDemand?.userId?.id,
      name: visitDemand?.name,
      phone: visitDemand?.phoneNumber,
      email: visitDemand?.email,
      status: mapReferenceStatusToVisitaStatus(
        mapReferenceStatusFromV3(structuredStatus?.status)
      ),
      hasAttended: followUp?.agentFollowUp?.visitorHasAttended,
      visitCode,
      schedulingId: tempMigrationSupport?.schedulingId,
    },
  ];
};

const createReferenceDatetimeFromStrings = (date, hour) => {
  if (!date || !hour) return null;
  const parsed = new Date(`${date}T${hour.length === 5 ? `${hour}:00` : hour}`);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatReferenceAgendaVisit = visit => {
  const { businessContext, singleHouseVisitDetails, visitConfiguration } =
    visit || {};
  const {
    houseDetails,
    visitTime,
    structuredStatus,
    followUp,
    tempMigrationSupport,
    actorDetails: { visitSupply, visitTenantLiving } = {},
  } = singleHouseVisitDetails || {};

  return {
    schedulingId: tempMigrationSupport?.schedulingId,
    house: formatReferenceHouseDetails(houseDetails),
    visitors: formatReferenceVisitors(visit),
    visitDate: createReferenceDatetimeFromStrings(
      visitTime?.date,
      visitTime?.beginHour
    ),
    formattedDate: visitTime?.date,
    startTime: visitTime?.beginHour,
    endTime: visitTime?.endHour,
    status: mapReferenceStatusToVisitaStatus(
      mapReferenceStatusFromV3(structuredStatus?.status)
    ),
    businessContext,
    visitNotHappen: followUp?.agentFollowUp?.visitNotHappen,
    isPrimaryMarket: houseDetails?.saleDetails?.isPrimaryMarket,
    isThirdPartyHouse: !!houseDetails?.isThirdParty,
    visitConfiguration,
    structuredStatus,
    ownerId: visitSupply?.userId?.id,
    visitTenantLiving,
    ownerPhone: visitSupply?.phoneNumber,
  };
};

export const getReferenceVisitsDateRange = ({
  currentTabIndex = 0,
  dates = [],
} = {}) => ({
  startDate: dates[currentTabIndex],
  endDate: dates[currentTabIndex],
});

export const buildReferenceVisitListParams = (
  businessContext,
  currentPage = REFERENCE_DEFAULT_CURRENT_PAGE,
  pageSize = REFERENCE_DEFAULT_PAGE_SIZE,
  requestedFields = REFERENCE_DEFAULT_REQUESTED_FIELDS,
  {
    startDate,
    endDate,
    status = REFERENCE_DEFAULT_VISIT_STATUS,
    houseIds,
    sortedBy = [],
    accessAuthorization,
    onBehalfOfRole,
    userSource,
    userId,
  } = {}
) =>
  compactObject({
    business_context: businessContext,
    page: currentPage,
    per_page: pageSize,
    requested_fields: requestedFields,
    start_date: startDate,
    end_date: endDate,
    status,
    imovel_ids: houseIds,
    sorted_by: sortedBy,
    access_authorization: accessAuthorization,
    on_behalf_of_role: onBehalfOfRole,
    user_source: userSource,
    user_id: userId,
  });

export const formatReferenceCreateVisitPayload = ({
  houseId,
  visitorId,
  date,
  slot,
  businessContext,
  confirmAfterCreation,
} = {}) =>
  compactObject({
    imovel_id: houseId,
    contact_id: visitorId,
    date,
    slot,
    business_context: businessContext,
    confirm_after_creation: confirmAfterCreation,
  });

export const formatReferenceRegisterVisitPayload = ({
  houseId,
  visitorId,
  date,
  slot,
  businessContext,
  comment,
  type,
  confirmAfterCreation,
} = {}) => ({
  ...formatReferenceCreateVisitPayload({
    houseId,
    visitorId,
    date,
    slot,
    businessContext,
    confirmAfterCreation,
  }),
  ...compactObject({ comment, buyer_visit_intention: type }),
});

export const formatReferenceRescheduleVisitPayload = ({
  houseId,
  date,
  slot,
  visitorId,
  businessContext,
  confirmAfterCreation,
} = {}) =>
  formatReferenceCreateVisitPayload({
    houseId,
    visitorId,
    date,
    slot,
    businessContext,
    confirmAfterCreation,
  });

const getReferenceReason = (
  reason,
  hasOwnerAttended,
  hasEntranceProblem,
  accessType = {}
) => {
  if (!hasOwnerAttended && accessType.ownerPresent) {
    return REFERENCE_ENTRANCE_PROBLEM_REASON.LANDLORD_NO_SHOW;
  }
  if (!hasEntranceProblem && hasOwnerAttended) {
    return REFERENCE_ACCESS_AUTHORIZATION.NONE;
  }
  return reason;
};

const getReferenceAuthorizationTypeUtilized = (
  accessAuthorizationType,
  hasOwnerAttended,
  hasEntranceProblem,
  house = {}
) => {
  if (accessAuthorizationType === REFERENCE_PRESENCE_ANSWER.DONT_KNOW) {
    return null;
  }
  if (!hasEntranceProblem && hasOwnerAttended) {
    return REFERENCE_CORRECT_ENTRY_INFO_OPTIONS.OWNER_PRESENT;
  }
  if (accessAuthorizationType) return accessAuthorizationType;
  if (hasEntranceProblem) return null;
  return house.authorization;
};

export const formatReferenceFollowUpPayload = ({
  agentHasKeys,
  houseId,
  visitor,
  comment,
  visitType,
  businessContext,
  agentHasAttended,
  visitorHasAttended,
  ownerPresence,
  keyProblem,
  entranceBlocker,
  entryInfoConfirmation,
  correctEntryInfo,
  entranceConfirmation,
  didEnter,
  accessType = {},
} = {}) => {
  const ownerHasAttended =
    agentHasAttended && ownerPresence?.includes(REFERENCE_PRESENCE_ANSWER.YES);
  const isMissPlacedKeys =
    entranceBlocker ===
      REFERENCE_ENTRANCE_BLOCKER_OPTIONS.WRONG_ENTRANCE_INFO ||
    entryInfoConfirmation?.includes(REFERENCE_PRESENCE_ANSWER.NO);
  const reason =
    agentHasAttended && isMissPlacedKeys
      ? REFERENCE_ENTRANCE_PROBLEM_REASON.MISSPLACED_KEYS
      : keyProblem || entranceBlocker;
  const hasEntranceProblem =
    didEnter?.includes(REFERENCE_PRESENCE_ANSWER.NO) ||
    (!agentHasAttended && !visitorHasAttended);
  const accessAuthorizationType = correctEntryInfo || entranceConfirmation;
  const accessAuthorizationTypeUtilized = getReferenceAuthorizationTypeUtilized(
    accessAuthorizationType,
    ownerHasAttended,
    hasEntranceProblem,
    accessType
  );

  return {
    agentHasKeys,
    agentHasAttended,
    ownerHasAttended,
    businessContext,
    visitors: [
      {
        visitorId: visitor?.id,
        schedulingId: visitor?.schedulingId,
        hasAttended: visitorHasAttended,
      },
    ],
    entranceProblem: {
      reason: getReferenceReason(
        reason,
        ownerHasAttended,
        hasEntranceProblem,
        accessType
      ),
      accessAuthorizationTypeUtilized,
      hasEntranceProblem,
    },
    houseId,
    comment,
    type: !agentHasAttended ? null : visitType,
  };
};

export const formatReferenceFollowUpProblemV3Payload = ({
  hasEntranceProblem,
  reason,
} = {}) =>
  hasEntranceProblem
    ? {
        reason: reason || REFERENCE_ACCESS_AUTHORIZATION.NONE,
      }
    : null;

export const formatReferenceFollowUpV3Payload = (payload = {}) => ({
  agentHasAttended: payload.agentHasAttended,
  visitorHasAttended: payload.visitors?.some(visitor => visitor?.hasAttended),
  ownerHasAttended: payload.ownerHasAttended || false,
  visitType: payload.type || REFERENCE_VISIT_TYPES.PRESENTIAL,
  comment: payload.comment,
  accessAuthorizationType:
    payload.entranceProblem?.accessAuthorizationTypeUtilized ||
    REFERENCE_ACCESS_AUTHORIZATION.NONE,
  agentHasKeys: payload.agentHasKeys,
  problem: formatReferenceFollowUpProblemV3Payload(payload.entranceProblem),
});

const hasInfo = value =>
  value &&
  ![REFERENCE_PRESENCE_ANSWER.DONT_KNOW, 'unknown'].includes(
    String(value).toLowerCase()
  );

const yesNoValue = value =>
  value === REFERENCE_PRESENCE_ANSWER.YES ? 'SIM' : 'NAO';

const amenitiesForMissingInfo = hasBalcony =>
  hasInfo(hasBalcony)
    ? [
        {
          key: REFERENCE_HOUSE_PRINCIPAL_INFOS.BALCONY,
          text: 'Varanda',
          value: yesNoValue(hasBalcony),
          optional: false,
        },
      ]
    : [];

const installationsForMissingInfo = (hasGym, hasPool) => {
  const result = [];
  if (hasInfo(hasGym)) {
    result.push({
      key: REFERENCE_HOUSE_PRINCIPAL_INFOS.GYM,
      text: 'Academia',
      value: yesNoValue(hasGym),
    });
  }
  if (hasInfo(hasPool)) {
    result.push({
      key: REFERENCE_HOUSE_PRINCIPAL_INFOS.POOL,
      text: 'Piscina',
      value: yesNoValue(hasPool),
    });
  }
  return result;
};

export const formatReferenceMissingInfoPayload = ({
  hasBalcony,
  hasGym,
  hasPool,
  hasElevator,
  hasDoorman,
} = {}) => ({
  amenities: amenitiesForMissingInfo(hasBalcony),
  installations: installationsForMissingInfo(hasGym, hasPool),
  ...(hasInfo(hasElevator)
    ? { hasElevator: hasElevator === REFERENCE_PRESENCE_ANSWER.YES }
    : {}),
  ...(hasInfo(hasDoorman) ? { doormanType: hasDoorman } : {}),
});
